import { useEffect, useState } from 'react'
import Chart from 'react-apexcharts'
import { Card } from 'components/Library'
import { colors } from 'components/Library/theme'

import { useSelector } from 'react-redux'

const TrafficSources = () => {
  const { pageAnalytics } = useSelector((state) => state.analytics)

  const [datosGrafico, setDatosGrafico] = useState([])

  useEffect(() => {
    if (pageAnalytics[3] && pageAnalytics[3].rowCount > 0) {
      const datos = []
      pageAnalytics[3].rows.forEach((analytic) => {
        // Obtener los valores de la iteración actual
        const fuente = analytic.dimensionValues[0].value // sessionSource
        const valor = analytic.metricValues[0].value // sessions
        datos.push({
          fuente: fuente === '(direct)' ? 'Directa' : fuente,
          valor: parseInt(valor)
        })
      })

      setDatosGrafico(datos)
    }
  }, [pageAnalytics])

  return (
    <Card style={{ padding: '2rem', width: '100%' }}>
      <Chart
        style={{ width: '100%' }}
        options={{
          chart: {
            toolbar: {
              show: false
            }
          },
          plotOptions: {
            bar: {
              borderRadius: 10,
              distributed: false
            }
          },
          stroke: {
            curve: 'straight'
          },
          legend: {
            show: false
          },
          xaxis: {
            categories: datosGrafico.map((item) => item.fuente)
          },
          title: {
            text: 'Fuentes de tráfico'
          },
          tooltip: {
            y: {
              formatter: parseInt
            }
          },
          colors: [colors.primary, colors.secondary, colors.tertiary]
        }}
        height={250}
        series={[
          {
            name: 'Sesiones',
            data: datosGrafico.map((item) => item.valor)
          }
        ]}
        type="bar"
      />
    </Card>
  )
}

export default TrafficSources
